import { IChatAttachmentCreate } from "../chat";
import { FileType } from "../documents/documents.types";

export enum AttachmentType {
    Scope = "scope",
    Folder = "folder",
    Comparison = "comparison",
    Document = "document",
}

export interface IAttachmentOption extends IChatAttachmentCreate {
    /**
     * Owning client of the underlying library item, when known at
     * selection time. Display-only (cross-client scope warning); never
     * sent to the backend. Missing/null means "no client" — no warning.
     */
    client_id?: number | null;
    /**
     * Underlying document's file type, when known at selection time.
     * Display-only: carried to the composer so the attachment pill can show a
     * spreadsheet (green) vs a PDF (red). Never sent to the backend — the send
     * path rebuilds briefs from aui state, and the backend re-resolves
     * `file_type` on reload. Only meaningful for `Document` attachments.
     */
    file_type?: FileType | null;
}
